import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Action, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';

import { SharedService } from 'src/app/core/services/shared.service';
import { InvestmentsState } from 'src/app/modules/investments/store/investments.reducer';
import { loadInvestments } from 'src/app/modules/investments/store/investments.actions';
import { InvestmentsParams } from 'src/app/modules/investments/investments.interface';
import { SelfPublishesState } from 'src/app/modules/self-publishes/store/self-publishes.reducer';
import { translations } from 'src/i18n/translations';
import { ContentType } from '../../helpers/enums';
import { FilesService } from 'src/app/core/services/files.service';
import { AdminFile } from 'src/app/core/interfaces/shared.interface';

declare const UIkit: any;

@Component({
  selector: 'app-admin-files-handler',
  templateUrl: './admin-files-handler.component.html',
  styleUrls: ['./admin-files-handler.component.scss']
})
export class AdminFilesHandlerComponent {
  adminFileUrl = `${this.sharedService.baseUrl}files/`;
  openFolder: number;
  dealflowFiles!: AdminFile[];

  @Input() action: (params: InvestmentsParams, pageNumber: number, notification?: string) => Action;
  @Input() index: number;
  @Input() state: Observable<InvestmentsState | SelfPublishesState>;
  @Output() changeOpenFolder = new EventEmitter<number>();

  @Input()
  set item(value: Record<string, any> & { id: string; dealflow_files: AdminFile[] }) {
    this._item = value;

    this.dealflowFiles = this.item?.dealflow_files?.filter((_) => !!_.file);
  }

  get item() {
    return this._item;
  }

  _item: Record<string, any> & { id: string; dealflow_files: AdminFile[] };

  constructor(
    private filesService: FilesService,
    private sharedService: SharedService,
    private store: Store<InvestmentsState | SelfPublishesState>
  ) {}

  closeFolder() {
    this.openFolder = null;
    this.changeOpenFolder.emit(this.openFolder);
  }

  deleteAdminFile(fileId: string): void {
    this.state
      .pipe(
        take(1),
        switchMap((state: InvestmentsState | SelfPublishesState) => {
          return this.filesService.deleteAdminFile(fileId).pipe(
            map(() => {
              this.store.dispatch(this.action(state.params, null, translations[this.sharedService.language].deleted));
              this.openFolder = null;
              this.changeOpenFolder.emit(this.openFolder);
            })
          );
        })
      )
      .subscribe();
  }

  toggleFolderIcon(index: number): void {
    this.openFolder = this.openFolder === index ? null : index;
    this.changeOpenFolder.emit(this.openFolder);
    UIkit.util.on('#drop-admin' + index, 'hidden', this.closeFolder.bind(this));
  }

  uploadFile(e: Event, itemId: string): void {
    const contentType = this.action === loadInvestments ? ContentType.Investment : ContentType.SelfPublish;
    const preparedFile = this.filesService.prepareFile((e.target as HTMLInputElement).files, contentType, itemId);

    this.state
      .pipe(
        take(1),
        switchMap((state: InvestmentsState | SelfPublishesState) => {
          return this.filesService
            .uploadFile(preparedFile)
            .pipe(map(() => this.store.dispatch(this.action(state.params, null, translations[this.sharedService.language].uploaded))));
        })
      )
      .subscribe();
  }
}
